import { IconPlus } from "@tabler/icons-react";
import type { ReactNode } from "react";
import { Button } from "./Button";
import { Card } from "./Card";
import { Group } from "./Group";
import { Heading } from "./Heading";
import { Stack } from "./Stack";
import { Text } from "./Text";

export interface CrearEntidadFormProps {
  titulo: string;
  descripcion?: ReactNode;
  /** Campos del formulario (Input/NumberInput/Select…) · el layout de grid lo pone esta molécula. */
  children: ReactNode;
  /** Columnas del grid en `md+` · en `base` siempre es 1 columna (mobile-first, igual que el original). */
  cols?: 2 | 3;
  onCancelar: () => void;
  onCrear: () => void;
  creando?: boolean;
  crearLabel?: string;
}

/**
 * Unifica los 9 `*CrearForm` casi-idénticos (`AreaCrearForm`,
 * `ProveedorCrearForm`, `OrganizacionCrearForm`, etc. · `INVENTARIO-UI.md`
 * §4.2). El patrón común portado: `Card` → header (título+ayuda) → grid de
 * campos (los campos los sigue definiendo cada feature, esta molécula NO
 * los conoce) → footer con Cancelar/Crear. La validación de "campo
 * obligatorio vacío" (`notifications.show({title:"Datos incompletos"...})`
 * en el original) sigue viviendo en cada feature — es la única parte que
 * varía según qué campos son requeridos.
 */
export function CrearEntidadForm({ titulo, descripcion, children, cols = 2, onCancelar, onCrear, creando = false, crearLabel = "Crear" }: CrearEntidadFormProps) {
  return (
    <Card padding="lg">
      <Stack gap="md">
        <div>
          <Heading order={5}>{titulo}</Heading>
          {descripcion && (
            <Text size="sm" c="dimmed" className="mt-0.5">
              {descripcion}
            </Text>
          )}
        </div>
        <div className={cols === 3 ? "grid grid-cols-1 gap-4 md:grid-cols-3" : "grid grid-cols-1 gap-4 md:grid-cols-2"}>
          {children}
        </div>
        <Group justify="flex-end">
          <Button variant="default" onClick={onCancelar}>
            Cancelar
          </Button>
          <Button leftSection={<IconPlus size={14} />} loading={creando} onClick={onCrear}>
            {crearLabel}
          </Button>
        </Group>
      </Stack>
    </Card>
  );
}
